document.addEventListener('DOMContentLoaded', function() {
  // Función para actualizar el precio por serving
  function updatePricePerServing() {
    // Seleccionamos el precio actual en el contenedor .price-container
    const priceElement = document.querySelector('.price-container #ProductPrice');
    if (!priceElement) return; // Si el elemento del precio no existe, salimos de la función.

    const priceText = priceElement.textContent.trim();

    // Verificamos si el precio no está vacío
    if (priceText) {
      // Extraemos solo el número, quitando el símbolo de dólar
      const priceValue = parseFloat(priceText.replace('$', ''));

      if (!isNaN(priceValue)) {
        // Dividimos el precio entre 8
        const pricePerServing = (priceValue / 8).toFixed(2);

        // Seleccionamos el contenedor donde se mostrará el precio por serving
        const priceInfoElement = document.querySelector('.product-price-info');

        // Actualizamos el contenido del div, manteniendo el span
        priceInfoElement.innerHTML = `$${pricePerServing} <span class="unit-n">/ serving</span>`;
      }
    }
  }
});


document.addEventListener('DOMContentLoaded', () => {
  function handleLabelClick(event) {
    // Eliminar la clase 'option-current-clicked' de todos los labels
    document.querySelectorAll('.option-name-choose-servings-size .servings-label').forEach(label => {
      label.classList.remove('option-current-clicked');
    });

    // Añadir la clase 'option-current-clicked' al label clickeado
    event.currentTarget.classList.add('option-current-clicked');

    // Actualizar visibilidad de las opciones de cantidad basadas en el tamaño de porción seleccionado
    updateQuantityOptions();
  }

  function updateQuantityOptions() {
    // Obtener el tamaño de porción seleccionado usando el data-option del label clickeado
    const selectedOption = document.querySelector('.option-name-choose-servings-size .servings-label.option-current-clicked')?.getAttribute('data-option') || '';

    // Obtener el label de la opción de cantidad "6-Pack" y "2-Pack"
    const sixPackOption = document.querySelector('.option-name-choose-quantity label[data-option="6-Pack"]');
    const twoPackOption = document.querySelector('.option-name-choose-quantity label[data-option="2-Pack"]');

    // Mostrar u ocultar la opción "6-Pack" y "2-Pack" según el tamaño de porción seleccionado
    if (selectedOption === '8 servings | 2oz') {
      if (sixPackOption) {
        sixPackOption.style.display = 'none';
      }
    } else {
      if (sixPackOption) {
        sixPackOption.style.display = '';
      }
    }

    // Si se selecciona "32 servings | 8oz" o "64 servings | 16oz", ocultar "2-Pack"
    if (selectedOption === '32 servings | 8oz' || selectedOption === '64 servings | 16oz') {
      if (twoPackOption) {
        twoPackOption.style.display = 'none';
      }
    } else {
      if (twoPackOption) {
        twoPackOption.style.display = '';
      }
    }
  }

  // Añadir el evento de clic a todos los labels dentro del contenedor
  document.querySelectorAll('.option-name-choose-servings-size .servings-label').forEach(label => {
    label.addEventListener('click', handleLabelClick);
  });

  // Marcar por defecto el label con data-option="8 servings | 2oz"
  const defaultLabel = document.querySelector('.option-name-choose-servings-size .servings-label[data-option="32 servings | 8oz"]');
  if (defaultLabel) {
    defaultLabel.classList.add('option-current-clicked');
  }

  // Inicializa el estado correcto de las opciones de cantidad al cargar la página
  updateQuantityOptions();
});

document.addEventListener('DOMContentLoaded', function() {
    var packSizeInputs = document.querySelectorAll('input.beta-quantity');
    var comparePriceElement = document.getElementById('ComparePrice');
    var oldPricePerBottleElement = document.querySelector('.old-ppb');
    var newPricePerBottleElement = document.querySelector('.new-ppb');
    var productPricePerBottleElement = document.querySelector('.product-price-per-bottle');

    function parsePrice(element) {
        if (element) {
            var text = element.textContent.trim();
            var price = text.replace(/[^\d.-]/g, ''); 
            return parseFloat(price) || 0;
        }
        return 0;
    }

    function updatePrices() {
        var selectedPackInput = Array.from(packSizeInputs).find(input => input.checked);
        var selectedPackSize = 0;

        if (selectedPackInput) {
            var value = selectedPackInput.value;
            if (value === "Single") {
                selectedPackSize = 1;
            } else {
                selectedPackSize = parseInt(value.split('-')[0]); 
            }
        }

        setTimeout(function() {
            var comparePrice = parsePrice(comparePriceElement);
            var newPriceElement = document.getElementById('ProductPrice');
            var newPrice = parsePrice(newPriceElement);

            if (selectedPackSize > 0 && !isNaN(comparePrice)) {
                var oldPricePerBottle = comparePrice / selectedPackSize;
                var newPricePerBottle = newPrice / selectedPackSize;

                if (oldPricePerBottle > 0 && oldPricePerBottle !== newPricePerBottle) {
                    oldPricePerBottleElement.innerText = '$' + Math.round(oldPricePerBottle);
                    oldPricePerBottleElement.style.display = 'flex';
                } else {
                    oldPricePerBottleElement.style.display = 'none'; 
                }

                if (newPricePerBottle > 0) {
                    newPricePerBottleElement.innerText = '$' + Math.round(newPricePerBottle);
                    newPricePerBottleElement.style.display = 'flex';
                    productPricePerBottleElement.style.display = 'flex';
                } else {
                    newPricePerBottleElement.style.display = 'none';
                    productPricePerBottleElement.style.display = 'none';
                }
            } else {
                oldPricePerBottleElement.style.display = 'none';
                newPricePerBottleElement.style.display = 'none';
                productPricePerBottleElement.style.display = 'none';
            }
        }, 0);
    }

    if (packSizeInputs.length > 0) {
        packSizeInputs.forEach(function(input) {
            input.addEventListener('change', updatePrices);
        });
    }

    if (comparePriceElement) {
        var observer = new MutationObserver(updatePrices);
        observer.observe(comparePriceElement, { childList: true, subtree: true });
    }

    var productPriceElement = document.getElementById('ProductPrice');
    if (productPriceElement) {
        var productPriceObserver = new MutationObserver(updatePrices);
        productPriceObserver.observe(productPriceElement, { childList: true, subtree: true });
    }

    if (packSizeInputs.length > 0 || comparePriceElement || productPriceElement) {
        updatePrices();
    }
});

document.addEventListener('DOMContentLoaded', function () {
  const videoPlayElement = document.querySelector('.miniature__video_play');
  
  if (videoPlayElement) {
    const backgroundImage = videoPlayElement.style.backgroundImage;
    const updatedImage = backgroundImage.replace('_small', '');
    videoPlayElement.style.backgroundImage = updatedImage;
  }
});

  // document.addEventListener("DOMContentLoaded", (event) => {
  //   // Automatically select the default options
  //   $("label[for='ProductSelect-option-choose-quantity-Single'] div.option-default").trigger("click");
  //   $("label[for='ProductSelect-option-choose-servings-size-32 servings | 8oz']").trigger("click");

  //   // Update the display based on the initial selections
  //   updateMoneySaved();
  // });

// Function to calculate the "SAVE X" amount

document.addEventListener('DOMContentLoaded', () => {
  // 1) Precios base por medida (oz)
  const nectarPrice2ozSingle  = 18;  // "8 servings | 2oz"
  const nectarPrice8ozSingle  = 39;  // "32 servings | 8oz"
  const nectarPrice16ozSingle = 72;  // "64 servings | 16oz"

  const basePriceMap = {
    '8 servings | 2oz':   nectarPrice2ozSingle,
    '32 servings | 8oz':  nectarPrice8ozSingle,
    '64 servings | 16oz': nectarPrice16ozSingle
  };

  // 2) Referencias al DOM
  const savingsBlocks  = document.querySelectorAll('.money-saved');
  const measureRadios  = document.querySelectorAll('input[name="option1"]');
  const packRadios     = document.querySelectorAll('input[name="option2"]');
  const subRadio       = document.getElementById('purchaseTypeSubscription');
  const oneTimeRadio   = document.getElementById('purchaseTypeOneTime');

  // 2bis) Capturamos el <h1> y guardamos su texto original
  const titleEl = document.querySelector('h1');
  const originalTitle = titleEl ? titleEl.textContent.trim() : '';

  // 3) Helper: extrae sólo el texto fuera de <s> y limpia
  function parsePrice(el) {
    if (!el) return 0;
    let text = '';
    el.childNodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE) text += node.textContent;
    });
    return parseFloat(text.replace(/[^0-9.]/g, '')) || 0;
  }

  // 4) Recalcula y muestra/oculta el ahorro en CADA bloque
  function updateSavings() {
    const selMeasure = document.querySelector('input[name="option1"]:checked');
    const selPack    = document.querySelector('input[name="option2"]:checked');

    // Si falta selección, ocultamos todo y restauramos título
    if (!selMeasure || !selPack) {
      savingsBlocks.forEach(b => b.style.display = 'none');
      if (titleEl) titleEl.textContent = originalTitle;
      return;
    }

    const measure    = selMeasure.getAttribute('data-option');
    const packCount  = parseInt(selPack.getAttribute('data-option'), 10) || 1;
    const baseSingle = basePriceMap[measure] || 0;

    // Excepción: 8 servings | 2oz + 6-pack
    if (measure === '8 servings | 2oz' && packCount === 6) {
      savingsBlocks.forEach(b => b.style.display = 'none');
      if (titleEl) titleEl.textContent = originalTitle;
      return;
    }

    // Coste original
    const originalCost = baseSingle * packCount;

    // Precio actual (subscription vs onetime)
    const priceEl = (subRadio && subRadio.checked)
      ? document.querySelector('[data-rtx-subscription-price]')
      : document.querySelector('[data-rtx-onetime-price]');
    if (!priceEl) {
      savingsBlocks.forEach(b => b.style.display = 'none');
      if (titleEl) titleEl.textContent = originalTitle;
      return;
    }
    const selectedPrice = parsePrice(priceEl);

    // Cálculo de ahorro
    const savings = originalCost - selectedPrice;
    if (savings <= 0) {
      savingsBlocks.forEach(b => b.style.display = 'none');
      if (titleEl) titleEl.textContent = originalTitle;
      return;
    }

    // Porcentaje
    const percent = Math.round((savings / originalCost) * 100);

    // Renderiza cada bloque
    savingsBlocks.forEach(block => {
      const origEl = block.querySelector('.original-price-tachado');
      const currEl = block.querySelector('.current-price');
      const pctEl  = block.querySelector('.savings-percent');
      const amtEl  = block.querySelector('.money-saved-amount');

      origEl.textContent     = `$${Math.round(originalCost)}`;
      currEl.textContent     = `$${Math.round(selectedPrice)}`;
      pctEl.textContent      = `-${percent}%`;
      amtEl.textContent      = `$${Math.round(savings)}`;
      block.style.display    = 'flex';
    });

    // —— dentro de updateSavings: Actualizamos el <h1> con el texto de servings
    if (titleEl) {
      const servingLabel = measure.split(' | ')[0]; // toma "8 servings", "32 servings" o "64 servings"
      titleEl.textContent = `${originalTitle} / ${servingLabel}`;
    }
  }

  // 5) Escucha cambios
  [...measureRadios, ...packRadios].forEach(r => r.addEventListener('change', updateSavings));
  if (subRadio)     subRadio.addEventListener('change', updateSavings);
  if (oneTimeRadio) oneTimeRadio.addEventListener('change', updateSavings);

  // 6) Lanza el cálculo inicial
  updateSavings();
});

